import { ArrowUpRight } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { ARTICLES } from "@/data/content";

export default function JournalList() {
  return (
    <section id="journal" data-testid="journal-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
      <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <div>
          <Eyebrow>The Journal</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight">
            From the editor's desk
          </h2>
        </div>
        <p className="text-sm text-slateblue max-w-xs leading-relaxed">
          Travel stories, seasonal roundups, and timely inspiration — publishing on a steady rhythm.
        </p>
      </Reveal>
      <div className="mt-12 border-t border-slateblue/20">
        {ARTICLES.map((a, i) => (
          <Reveal key={a.index} delay={i * 0.06}>
            <div
              data-testid={`journal-article-${a.index}`}
              className="group grid grid-cols-[auto_1fr_auto] sm:grid-cols-[64px_1fr_auto_auto] items-center gap-5 sm:gap-8 py-7 border-b border-slateblue/20 transition-colors duration-300 hover:bg-white/70 cursor-pointer"
            >
              <span className="font-mono text-sm text-gold">{a.index}</span>
              <div>
                <p className="text-[10px] tracking-[0.22em] uppercase text-slateblue font-semibold">{a.category}</p>
                <h3 className="mt-1.5 font-serif text-lg sm:text-2xl text-navy leading-snug group-hover:text-ocean transition-colors duration-300">
                  {a.title}
                </h3>
              </div>
              <span className="hidden sm:block text-xs text-slateblue whitespace-nowrap">{a.time}</span>
              <ArrowUpRight className="h-5 w-5 text-slateblue transition-all duration-300 group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-6 text-xs text-slateblue italic" data-testid="journal-note">
          Full articles are on their way — join the Venture List below to read them first.
        </p>
      </Reveal>
    </section>
  );
}
